import React, { useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import styles from './Root.module.css'
import Chrome from './Chrome'
import Footer from './Footer'
import Home from './Home'
import Post from './Post'

export default () => {
  const [filter, setFilter] = useState('all')
  return (
    <div className={styles['app-container']}>
      <Chrome>Data Looks Dope</Chrome>
      <div className={styles['content-container']}>
        <Switch>
          <Route exact path="/">
            {() => <Home filter={filter} setFilter={setFilter} />}
          </Route>
          <Route path="/:slug">{props => <Post {...props} />}</Route>
          <Redirect to="/" />
        </Switch>
      </div>
      <Footer />
    </div>
  )
}
